import { useEffect, useRef } from "react";

export const MotionLayer = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const root = document.documentElement;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const onScroll = () => {
      const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const p = window.scrollY / max;
      root.style.setProperty("--scroll", p.toFixed(4));
      root.style.setProperty("--scroll-y", `${window.scrollY}px`);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    const observed = Array.from(document.querySelectorAll("[data-motion]"));
    let observer;
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-inview");
        });
      }, { threshold: .16, rootMargin: "0px 0px -8% 0px" });
      observed.forEach((el) => observer.observe(el));
    } else observed.forEach((el) => el.classList.add("is-inview"));

    if (reduce || !window.matchMedia("(pointer:fine)").matches) return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };

    let tx = window.innerWidth / 2, ty = window.innerHeight / 2, rx = tx, ry = ty, raf = 0;
    const draw = () => {
      rx += (tx - rx) * .15; ry += (ty - ry) * .15;
      if (dotRef.current) dotRef.current.style.transform = `translate3d(${tx}px,${ty}px,0)`;
      if (ringRef.current) ringRef.current.style.transform = `translate3d(${rx}px,${ry}px,0)`;
      raf = requestAnimationFrame(draw);
    };
    const move = (e) => { tx = e.clientX; ty = e.clientY; };
    const over = (e) => {
      const hot = e.target.closest("a,button,.pillar,.stack-layer,.archive-card,.service-panel-v71");
      ringRef.current?.classList.toggle("is-hot", Boolean(hot));
    };
    window.addEventListener("pointermove", move, { passive: true });
    window.addEventListener("pointerover", over, { passive: true });
    draw();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerover", over);
      observer?.disconnect(); cancelAnimationFrame(raf);
    };
  }, []);

  return <><div ref={ringRef} className="cursor-ring" aria-hidden="true"/><div ref={dotRef} className="cursor-dot" aria-hidden="true"/><div className="scroll-progress" aria-hidden="true"><i/></div></>;
};
